import {axios} from '../Api';

class ImageService {
    persistSettings = (id, amplitude, spread) => {
        return axios.put(`/app/api/image/${id}/updateParams?amplitude=${amplitude}&spread=${spread}`);
    };

    getImagesAndUser = async (userId) => {
        const result = await axios.get(`/app/api/images?userId=${userId}`);
        return result.data;
    };

    getImage = async (id) => {
        const response = await axios.get(`/app/api/image/${id}`);
        return response.data;
    };

    getImageByUploadId = async (uploadId) => {
        const response = await axios.get(`/app/api/search/image/fileUploadId/${uploadId}`);
        return response.data;
    };

    deleteImage = (id, uploadId = null) => {
        const url = id ? `/app/api/image/${id}` : `/app/api/search/image/fileUploadId/${uploadId}`;
        return axios.delete(url);
    };

    deleteImages = (ids) => {
        return axios.post('/app/api/images/delete', ids);
    };
}

export default new ImageService();



// WEBPACK FOOTER //
// ./src/services/ImageService.js